import { workspaceLink } from './workspaceNavigation'
import { setupDirectory, setupLocation } from './setupDirectory'

const displaySegment = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1).replaceAll('-', ' ')
function tail(path: string) {
  return path
    .split('/')
    .filter((segment) => segment && !/^\d+$/.test(segment))
    .map(displaySegment)
}

export function workspaceTrail(fullPath: string, custom?: unknown): string[] {
  const path = fullPath.split(/[?#]/)[0]!.replace(/\/+$/, '') || '/'
  if (path === '/setup') {
    const query = new URLSearchParams(fullPath.split('#')[0]!.split('?')[1])
    const category = setupDirectory.find(
      (group) => group.id === query.get('category')
    )
    if (query.get('q')?.trim()) return ['Admin', 'Setup', 'Search results']
    if (category) return ['Admin', 'Setup', category.label]
  }
  const setting = setupLocation(path)
  if (setting && path.startsWith('/setup/')) {
    return [
      'Admin',
      'Setup',
      setting.group.label,
      setting.item.label,
      ...tail(path.slice(setting.item.to.length)),
    ]
  }
  if (setting?.item.to === '/leads/tracking/settings')
    return ['Marketing', 'Inquiry', setting.item.label]
  if (Array.isArray(custom)) return custom
  const match = workspaceLink(fullPath)
  if (match) {
    const { section, item, base } = match
    const trail = section === item.label ? [section] : [section, item.label]
    return [...trail, ...tail(path.slice(base.length))]
  }
  if (path.startsWith('/crm/leads'))
    return [
      'Campaigns',
      'Contact lists',
      'Previous contact records',
      ...tail(path.slice('/crm/leads'.length)),
    ]
  if (path.startsWith('/comms/blasts'))
    return [
      'Campaigns',
      'Blast history',
      ...tail(path.slice('/comms/blasts'.length)),
    ]
  const parts = tail(path)
  if (parts[0] === 'Comms')
    return ['Admin', 'Communications', ...parts.slice(1)]
  return parts
}
